(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

document.addEventListener('click', event => {
  const link = event.target.closest('.mobile-menu a');
  if (link) link.closest('details').open = false;
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') document.querySelectorAll('.site-header details[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

function initializeRugProduct(root) {
  root.querySelectorAll('[data-product-section]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const select = section.querySelector('[data-variant-select]');
    if (select) select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const available = option.dataset.available === 'true';
      section.querySelector('[data-variant-price]').textContent = option.dataset.price;
      section.querySelector('[data-variant-status]').textContent = option.dataset.status;
      const button = section.querySelector('[data-add-button]');
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    });
    const dialog = section.querySelector('dialog');
    if (!dialog || !dialog.showModal) return;
    let previousFocus;
    section.querySelectorAll('[data-zoom-link]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      previousFocus = link;
      dialog.querySelector('img').src = link.href;
      dialog.querySelector('img').alt = link.querySelector('img').alt;
      dialog.showModal();
    }));
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => previousFocus?.focus());
  });
}
initializeRugProduct(document);
document.addEventListener('shopify:section:load', event => initializeRugProduct(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ra-quote"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('input[name="contact[Requested deadline]"]').forEach(input => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  input.min = `${year}-${month}-${day}`;
});
document.querySelectorAll('[data-quote-section]').forEach(section => {
  const rug = new URL(window.location.href).searchParams.get('rug');
  const details = section.querySelector('textarea[name="contact[body]"]');
  if (rug && details && !details.value.trim()) details.value = section.dataset.rugPrefill + ' ' + rug.slice(0,180) + '\n\n';
});


  } catch(e) { console.error(e); }
})();
})();
